import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Table } from 'components/Table';
import { SessionRow } from './SessionRow';
import styles from './SessionHistory.scss';

export const SessionHistory = ({ sessions, canManage, onCloseSession }) => {
  const [expandedSession, setExpandedSession] = useState(null);

  const formatDuration = (minutes) => {
    if (!minutes) return '—';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}г ${mins}хв`;
  };

  return sessions.length === 0 ? (
    <div className={styles.noSessions}>
      <FontAwesomeIcon icon={faInfoCircle} />
      <p>Немає сесій за вибраний період</p>
    </div>
  ) : (
    <Table
      className={styles.table}
      columns={[
        { key: 'type', label: 'Тип' },
        { key: 'loginTime', label: 'Початок сесії' },
        { key: 'logoutTime', label: 'Кінець сесії' },
        { key: 'duration', label: 'Тривалість' },
        { key: 'status', label: 'Статус' },
        { key: 'actions', label: '' },
      ]}
      data={sessions}
      renderRow={(session) => (
        <SessionRow
          key={session.id}
          session={session}
          canManage={canManage}
          onCloseSession={onCloseSession}
          formatDuration={formatDuration}
          expandedSession={expandedSession}
          setExpandedSession={setExpandedSession}
        />
      )}
    />
  );
};
